module.exports = __webpack_public_path__ + "static/img/p1.d0ae5c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p1.png
// module id = 5cxE
// module chunks = 0